import { atom } from 'jotai';

import type { ParsedEngagementRecord } from '../hooks/useParseRecords';

// Data atoms for engagement records
export const engagementRecordsAtom = atom<ParsedEngagementRecord[]>([]);
export const isLoadingRecordsAtom = atom<boolean>(false);
export const recordsErrorAtom = atom<Error | null>(null);

// Incremented to trigger a full reload of engagement records
export const reloadRecordsAtom = atom<number>(0);

// Tracks the reloadRecords token that produced the currently loaded data, so the
// loader can skip re-fetching the full dataset when the dashboard re-mounts (e.g.
// navigating back from the detail page). Null until the first load completes.
export const loadedReloadTokenAtom = atom<number | null>(null);

// Pagination atoms
export const currentPageAtom = atom<number>(0);
export const pageSizeAtom = atom<number>(50);
export const totalRecordsAtom = atom<number>(0);

// Selected record atom (for details view)
export const selectedRecordIdAtom = atom<string | null>(null);

/**
 * Write-only atom that marks the engagement record (matched by its engagement
 * record id) as executed, i.e. as having at least one iManage document. This
 * keeps the already-loaded main grid in sync when the first doc link is added,
 * without triggering a full reload of the ~140k-row dataset. No-op when the
 * record is not loaded or already shows as executed.
 */
export const markEngagementRecordExecutedAtom = atom(null, (_get, set, engagementRecordId: string) => {
  if (!engagementRecordId) return;
  set(engagementRecordsAtom, (records) =>
    records.map((record) =>
      record.engagementRecordId === engagementRecordId && !record.isExecuted ? { ...record, isExecuted: true } : record,
    ),
  );
});
